import { useState, useEffect } from 'react';
"use strict";
const useIsAtMaxScroll = container => {
  const [isMax, setIsMax] = useState({
    left: false,
    right: false
  });
  useEffect(() => {
    const containerRef = container.current;
    if (!containerRef) return;
    const update = () => setIsMax({
      left: containerRef.scrollLeft <= 0,
      right: containerRef.scrollLeft !== containerRef.scrollWidth - containerRef.clientWidth
    });
    update();
    containerRef.addEventListener("scroll", update);
    return () => {
      containerRef.removeEventListener("scroll", update);
    };
  }, [container]);
  return {
    isMaxLeft: isMax.left,
    isMaxRight: isMax.right
  };
};
export { useIsAtMaxScroll };
//# sourceMappingURL=useIsAtMaxScroll.mjs.map
